import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from 'react-i18next';
import NavbarBottom from "../components/NavbarBottom";
import LanguageSwitcher from "../components/LanguageSwitcher";
import phoneIcon from "../assets/phone-call.png";
import { getCountryCode } from "../Firebase";

function readMobiLoginResult() {
  try {
    const raw = sessionStorage.getItem("AI_MobiLoginResponse");
    if (!raw) return {};
    const data = JSON.parse(raw);
    const r = data?.Result;
    return r && typeof r === "object" ? r : {};
  } catch {
    return {};
  }
}

export default function Profile() {
  const { t } = useTranslation();
  const [phone, setPhone] = useState(null);
  const [country, setCountry] = useState("");
  const [iframeModal, setIframeModal] = useState({
    open: false,
    url: "",
    title: "",
  });
  const userData = useMemo(() => {
    try {
      const raw = sessionStorage.getItem("AI_UserData");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const mobiResult = useMemo(() => readMobiLoginResult(), []);

  const msisdn = phone ? String(phone).replace(/\D/g, "") : "";
  const bcid = mobiResult?.billingChannelId;

  const accountDetailsUrl =
    bcid != null && bcid !== "" && msisdn
      ? `https://apis.mymobibox.mobi/API/InAppWAP/MAD/?bcid=${bcid}&MSISDN=${encodeURIComponent(
          msisdn
        )}&langCode=en`
      : null;

  const unsubUrl =
    bcid != null && bcid !== "" && msisdn
      ? `https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${bcid}&MSISDN=${encodeURIComponent(
          msisdn
        )}&langCode=en`
      : null;

  const showAccountDetails =
    !!(mobiResult?.ShowAccountDetails || mobiResult?.showMyAccountDetails) &&
    accountDetailsUrl;

  const showUnsubscribe =
    mobiResult?.showUnsub === true && !!unsubUrl;

  useEffect(() => {
    if (userData) {
      setPhone(userData.phone);
    }
  }, [userData]);

  useEffect(() => {
    getCountryCode()
      .then((countryText) => {
        console.log("Country:", countryText);
        setCountry(countryText);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  useEffect(() => {
    if (!iframeModal.open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setIframeModal({ open: false, url: "", title: "" });
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [iframeModal.open]);

  const closeIframeModal = () => {
    setIframeModal({ open: false, url: "", title: "" });
  };

  const openAccountDetailsModal = () => {
    if (!accountDetailsUrl) return;
    setIframeModal({
      open: true,
      url: accountDetailsUrl,
      title: t("portal.profile.accountDetails"),
    });
  };

  const openUnsubscribeModal = () => {
    if (!unsubUrl) return;
    setIframeModal({
      open: true,
      url: unsubUrl,
      title: t("portal.profile.unsubscribe"),
    });
  };

  // ---------------------------
  // Logout function
  // ---------------------------
  const handleLogout = () => {
    // Remove all session storage
    sessionStorage.clear();

    // Remove i18n preference
    localStorage.removeItem('i18nextLng');

    // Redirect to domain root
    window.location.href = "/";
  };

  // ---------------------------
  // Render
  // ---------------------------
  return (
    <>
      <div className="container pt-4" style={{ marginBottom: "12rem" }}>
        <h1>{t('portal.profile.title')}</h1>

        <div
          style={{ background: "#ffffff91" }}
          className="d-flex align-items-center gap-4 mt-5 justify-content-between p-4 br_10"
        >
          <div className="d-flex align-items-center gap-4">
            <img style={{ maxHeight: "30px" }} src={phoneIcon} alt="Phone" />
            <div>
              <h1 className="p-0 m-0">{phone}</h1>
            </div>
          </div>
        </div>

        <div
          style={{ background: "#ffffff91" }}
          className="d-flex flex-column align-items-center gap-4 mt-5 p-4 br_10"
        >
          <div className="d-flex gap-4 align-items-center justify-content-between w-100">
            <h2>{t('portal.profile.languages')}</h2>
            <LanguageSwitcher />
          </div>

          <div className="separator"></div>

          <div className="d-flex align-items-center justify-content-between w-100">
            <h2
              onClick={() => (window.location.href = "/Portal/privacy")}
              style={{ cursor: "pointer" }}
            >
              {t('portal.profile.privacyPolicy')}
            </h2>
          </div>
          <div className="separator"></div>

          <div className="d-flex align-items-center justify-content-between w-100">
            <h2
              onClick={() => (window.location.href = "/Portal/terms")}
              style={{ cursor: "pointer" }}
            >
              {t('portal.profile.termsConditions')}
            </h2>
          </div>

          {showAccountDetails && (
            <>
              <div className="separator"></div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <h2
                  onClick={openAccountDetailsModal}
                  style={{ cursor: "pointer" }}
                >
                  {t("portal.profile.accountDetails")}
                </h2>
              </div>
            </>
          )}

          {showUnsubscribe && (
            <>
              <div className="separator"></div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <h2
                  onClick={openUnsubscribeModal}
                  style={{ cursor: "pointer" }}
                >
                  {t("portal.profile.unsubscribe")}
                </h2>
              </div>
            </>
          )}

          {country.trim().toUpperCase() === "GR" && (
            <>
              <div className="separator"></div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <h2
                  onClick={() => (window.location.href = "/Portal/contact")}
                  style={{ cursor: "pointer" }}
                >
                  {t('portal.profile.contactUs')}
                </h2>
              </div>
              <div className="separator"></div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <h2
                  onClick={() => (window.location.href = "/Portal/faq")}
                  style={{ cursor: "pointer" }}
                >
                  {t('portal.profile.faq')}
                </h2>
              </div>
            </>
          )}
          <div className="separator"></div>
          <div
            className="d-flex align-items-center justify-content-between w-100"
            style={{ cursor: "pointer" }}
          >
            <h2 onClick={() => handleLogout()}>{t('portal.profile.logout')}</h2>
          </div>
        </div>
      </div>

      {iframeModal.open && iframeModal.url ? (
        <div
          className="resetModal"
          role="presentation"
          onClick={closeIframeModal}
        >
          <div
            className="portalIframeModalPanel"
            role="dialog"
            aria-modal="true"
            aria-labelledby="portal-iframe-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="portalIframeModalHeader">
              <h2 id="portal-iframe-modal-title">{iframeModal.title}</h2>
              <button
                type="button"
                className="portalIframeModalClose"
                onClick={closeIframeModal}
                aria-label={t("common.close")}
              >
                ✖
              </button>
            </div>
            <iframe
              className="portalIframeModalFrame"
              title={iframeModal.title}
              src={iframeModal.url}
            />
          </div>
        </div>
      ) : null}

      <NavbarBottom />
    </>
  );
}
